export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyBQ7HmZOVVfmtuOLXmLu2uCkkRNgAc_nB4',
    authDomain: 'pe-gcp-customercare-02.firebaseapp.com',
    databaseURL: 'https://pe-gcp-customercare-02-default-rtdb.firebaseio.com',
    projectId: 'pe-gcp-customercare-02',
    storageBucket: 'pe-gcp-customercare-02.appspot.com',
    messagingSenderId: '52415902569',
    appId: '1:52415902569:web:fd3a56d74b654ef52743f8',
    measurementId: 'G-SVNG5R05EC',
  },
  apiOrigin: 'https://api.cc-irdigital.pe',
  apiAdminUrl: 'https://api.cc-irdigital.pe/irma/cc-irma-admin',
  apiAuthUrl: 'https://api.cc-irdigital.pe/public/cc-auth-svc',
  orchestratorApiBaseUrl: 'https://api.cc-irdigital.pe/irma/cc-irma-orchestrator',
  productCode: 'IRMA',
  requestedBy: 'irma-web',
  envName: 'dev_'
};
